var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 84.031,
    height: 86.048,
    viewBox: "0 0 84.031 86.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1777",
    "data-name": "Rectangle 1777",
    width: 57.784,
    height: 43.03,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6213",
    "data-name": "Group 6213",
    transform: "translate(-981.585 -5578.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8966",
    "data-name": "Path 8966",
    d: "M96.082,37.1V18.356C96.082,8.373,103.434.25,112.468.25h13.245c9.036,0,16.388,8.123,16.388,18.106V37.1c0,9.982-7.352,18.1-16.388,18.1H112.468c-9.034,0-16.386-8.121-16.386-18.1M112.468,8.783c-4.778,0-8.664,4.3-8.664,9.573V37.1c0,5.277,3.886,9.571,8.664,9.571h13.245c4.778,0,8.664-4.294,8.664-9.571V18.356c0-5.277-3.886-9.573-8.664-9.573Z",
    transform: "translate(895.964 5578.5)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8968",
    "data-name": "Path 8968",
    d: "M98.848,70.48h51.346a7.8,7.8,0,0,0,7.8-7.8V22.7a7.8,7.8,0,0,0-7.8-7.8H98.848a7.8,7.8,0,0,0-7.8,7.8V62.683a7.8,7.8,0,0,0,7.8,7.8",
    transform: "translate(890.534 5594.318)",
    fill: "#ea3943"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6212",
    "data-name": "Group 6212",
    transform: "translate(986.163 5616.827)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5793",
    "data-name": "Group 5793",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5792",
    "data-name": "Group 5792",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8460",
    "data-name": "Path 8460",
    d: "M101.05,61.593h42.189a7.8,7.8,0,0,0,7.8-7.8V26.361a7.8,7.8,0,0,0-7.8-7.8H101.05a7.8,7.8,0,0,0-7.8,7.8V53.8a7.8,7.8,0,0,0,7.8,7.8",
    transform: "translate(-93.252 -18.562)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8970",
    "data-name": "Path 8970",
    d: "M103.39,30.012a7.815,7.815,0,1,1,10.078,7.444V47.562h-4.526V37.455a7.79,7.79,0,0,1-5.551-7.444",
    transform: "translate(903.851 5602.184)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8971",
    "data-name": "Path 8971",
    d: "M142.3,24.638a12.59,12.59,0,1,1-12.59-12.59,12.59,12.59,0,0,1,12.59,12.59",
    transform: "translate(918.667 5591.232)",
    fill: "#ea3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8972",
    "data-name": "Path 8972",
    d: "M117.522,38.975a.545.545,0,0,1,.771-.771,16,16,0,1,0,0-22.624.545.545,0,0,1-.771-.771,17.088,17.088,0,1,1,0,24.167",
    transform: "translate(918.929 5588.819)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8973",
    "data-name": "Path 8973",
    d: "M123.951,28.236a1.687,1.687,0,0,1-1.193-.439,1.4,1.4,0,0,1-.47-1.065,1.359,1.359,0,0,1,.474-1.067,1.746,1.746,0,0,1,1.189-.416,1.7,1.7,0,0,1,1.185.42,1.378,1.378,0,0,1,.462,1.062,1.4,1.4,0,0,1-.457,1.077,1.668,1.668,0,0,1-1.189.426m1.435-11.928-.258,6.531a1.2,1.2,0,0,1-2.4,0l-.245-6.529a1.2,1.2,0,0,1,1.2-1.248h.5a1.2,1.2,0,0,1,1.2,1.25",
    transform: "translate(924.245 5594.481)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUser);
export default __webpack_public_path__ + "static/media/no_user.86c077afc385df6e8131529d83544d17.svg";
export { ForwardRef as ReactComponent };